import Swiper from 'swiper/bundle';

export default function initSlider() {
  document.querySelectorAll('.slider-block').forEach(el => {
    const pagination = el.querySelector('.slider-pagination');
    
    const swiper = new Swiper(el, {
      speed: 900,
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      mousewheel: !1,
      breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20,
          }
      },
      pagination: {
          el: pagination,
          clickable: true,
      },
    })
  });

  document.querySelectorAll('.slider').forEach(el => {
    const holder = el.closest('section')
    const pagination = el.querySelector('.slider-pagination');
    const btnPrev = holder.querySelector('.swiper-button-prev');
    const btnNext = holder.querySelector('.swiper-button-next');

    const swiper = new Swiper(el, {
      speed: 900,
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      loopedSlides: 1,

      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },

      pagination: {
        el: pagination,
        clickable: true,
      },
    })
  });

  document.querySelectorAll('.hero-slider').forEach(el => {
    const holder = el.closest('.hero-section')
    const pagination = el.querySelector('.slider-pagination');
    const btnPrev = holder.querySelector('.swiper-button-prev');
    const btnNext = holder.querySelector('.swiper-button-next');

    const swiper = new Swiper(el, {
      speed: 2000,
      loop: true,
      autoplay: {
          delay: 5000,
          disableOnInteraction: false,
      },
      
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },

      pagination: {
        el: pagination,
        clickable: true,
      },
    })
  });
  
  document.querySelectorAll('.marquee').forEach(holder => {
    const speed = 3000;

    const count = holder.querySelectorAll("li").length * speed;

    holder.setAttribute('style', `--speed: ${count}ms`)
  });
}
